if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.touchTap = null;
        this.pendingTouchClose = false;
        this.pendingTouchCloseTimer = null;

        this.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'touch') return;

          const image = event.target.closest('img');
          if (!image) return;

          const activeMedia = image.closest('[data-media-id]');
          if (!activeMedia || !activeMedia.classList.contains('active')) return;

          if (image.closest('deferred-media, product-model')) return;

          this.touchTap = {
            pointerId: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            time: performance.now(),
            moved: false,
          };
        });

        this.addEventListener(
          'pointermove',
          (event) => {
            if (!this.touchTap || event.pointerId !== this.touchTap.pointerId) return;

            const distanceX = Math.abs(event.clientX - this.touchTap.x);
            const distanceY = Math.abs(event.clientY - this.touchTap.y);

            if (distanceX > 10 || distanceY > 10) {
              this.touchTap.moved = true;
            }
          },
          { passive: true }
        );

        this.addEventListener('pointerup', (event) => {
          if (!this.touchTap || event.pointerId !== this.touchTap.pointerId) return;

          const tap = this.touchTap;
          this.touchTap = null;

          const duration = performance.now() - tap.time;

          // Do NOT close yet.
          // Wait for the click generated by this touch.
          if (!tap.moved && duration < 400) {
            this.pendingTouchClose = true;

            clearTimeout(this.pendingTouchCloseTimer);
            this.pendingTouchCloseTimer = setTimeout(() => {
              this.pendingTouchClose = false;
            }, 700);
          }
        });

        /*
         * A touch normally produces:
         *
         * pointerdown
         * pointerup
         * click
         *
         * We keep the modal open until the click arrives, consume that
         * click here, and only THEN close the modal. This prevents the
         * click falling through onto the gallery underneath.
         */
        this.addEventListener(
          'click',
          (event) => {
            if (!this.pendingTouchClose) return;

            const image = event.target.closest('img');
            if (!image) return;

            const activeMedia = image.closest('[data-media-id]');
            if (!activeMedia || !activeMedia.classList.contains('active')) return;

            this.pendingTouchClose = false;
            clearTimeout(this.pendingTouchCloseTimer);

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            this.hide();
          },
          true
        );

        this.addEventListener('pointercancel', () => {
          this.touchTap = null;
          this.pendingTouchClose = false;
          clearTimeout(this.pendingTouchCloseTimer);
        });
      }

      hide() {
        this.touchTap = null;
        this.pendingTouchClose = false;
        clearTimeout(this.pendingTouchCloseTimer);

        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}